import React from 'react';
import styled from 'styled-components';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
// import SiteType from 'interfaces/SiteType';
import {Site} from 'hooks/useSiteInfo/interfaces/Site';
import SiteType from 'hooks/useSiteInfo/interfaces/SiteType';
import SiteState from 'hooks/useSiteInfo/interfaces/SiteState';
import SiteTypeOption from '../interfaces/SiteTypeOption';
import {MinimumSiteInfoState} from 'redux/reducers/minimumSiteInfoReducer';

const StyledFormControlLabel = styled(FormControlLabel)`
  margin-right: 20px;
  margin-bottom: 4px;
  .MuiTypography-body1 {
    font-size: 0.875rem;
  }
  &:last-of-type {
    margin-right: 0;
  }
`;

const StyledRadioButton = styled(Radio)`
  color: ${props => props.theme.text};
  padding: 4px;
  &.Mui-checked {
    color: ${props => props.theme.text};
  }
`;

interface SiteTypeSelectionProps {
  selectedSiteType: SiteTypeOption;
  setSelectedSiteType: (siteType: SiteTypeOption) => void;
  siteInfoState: SiteState;
  className?: string;
}

export default function SwitchConnectivityInstance({
  selectedSiteType,
  setSelectedSiteType,
  siteInfoState,
  className,
}: SiteTypeSelectionProps) {
  const {allSiteTypes} = siteInfoState;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedSiteType(event.target.value as SiteTypeOption);
  };

  return (
    <FormControl component="fieldset" size="small" className={className ? className : ''}>
      <RadioGroup
        row
        aria-label="Select Site Type"
        name="Select Site Type"
        value={selectedSiteType}
        onChange={handleChange}
      >
        <StyledFormControlLabel
          value={SiteTypeOption.All}
          control={<StyledRadioButton color="primary" size="small" />}
          label="All"
        />
        {allSiteTypes.has(SiteType.Retail) && (
          <StyledFormControlLabel
            value={SiteTypeOption.Retail}
            control={<StyledRadioButton color="primary" size="small" />}
            label="Retail"
          />
        )}
        {allSiteTypes.has(SiteType.Showroom) && (
          <StyledFormControlLabel
            value={SiteTypeOption.Showroom}
            control={<StyledRadioButton color="primary" size="small" />}
            label="Showroom"
          />
        )}
        {allSiteTypes.has(SiteType.DataCenter) && (
          <StyledFormControlLabel
            value={SiteTypeOption.Distribution}
            control={<StyledRadioButton color="primary" size="small" />}
            label="Distribution Center"
          />
        )}
        {(allSiteTypes.has(SiteType.Corporate) ||
          allSiteTypes.has(SiteType.Headquarters) ||
          allSiteTypes.has(SiteType.Office)) && (
          <StyledFormControlLabel
            value={SiteTypeOption.Corporate}
            control={<StyledRadioButton color="primary" size="small" />}
            label="HQ / Remote Office"
          />
        )}
        {(allSiteTypes.has(SiteType.DataCenter) || allSiteTypes.has(SiteType.Gwan)) && (
          <StyledFormControlLabel
            value={SiteTypeOption.DataCenter}
            control={<StyledRadioButton color="primary" size="small" />}
            label="Data Center"
          />
        )}
        {allSiteTypes.has(SiteType.Lab) && (
          <StyledFormControlLabel
            value={SiteTypeOption.Lab}
            control={<StyledRadioButton color="primary" size="small" />}
            label="Lab"
          />
        )}
      </RadioGroup>
    </FormControl>
  );
}
